import React, {useEffect, useState} from 'react';
import {doGetTabelogRestaurantMenu, doGetTabelogRestaurants, doPostTabelogDish} from "../../logic/dish";
import {useTranslation} from "react-i18next";
import {useDish} from "../../utils/contexts/dish-context";
import Button from "../UI/Button";
import BaseInput from "../UI/BaseInput";
import Loading from "../UI/Loading";
import Description from "../UI/Text/Description";
import {useApi} from "../../utils/hooks/api";
import {useNavigate} from "react-router-dom";

const TabelogInput = () => {

    const {setTabelogData, tabelogUrl, setTabelogUrl} = useDish();
    const {t, i18n} = useTranslation();
    const {call, loading} = useApi();
    const {call: callRestaurants, loading: loadingRestaurants} = useApi();
    const navigate = useNavigate();

    const [restaurants, setRestaurants] = useState([]);

    useEffect(() => {
        callRestaurants(
            () => doGetTabelogRestaurants(i18n.language),
            (res) => {
                if (res) {
                    setRestaurants(res);
                }
            }
        )
    }, [i18n.language]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        await call(
            () => doPostTabelogDish(tabelogUrl, i18n.language),
            (res) => {
                if (res) {
                    setTabelogData(res);
                    navigate('/tabelog_data');
                }
            }
        )
    }

    const handleSelectRestaurant = async (e) => {
        const restaurantId = e.target.value;
        if (!restaurantId) return;

        await call(
            () => doGetTabelogRestaurantMenu(restaurantId, i18n.language),
            (res) => {
                if (res) {
                    setTabelogData(res);
                    navigate('/tabelog_data');
                }
            }
        )
    }

    return (
        <div>
            <Description>{t('tabelog.url_input_text', 'ENTER A TABELOG URL')}</Description>
            <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
                <div className="flex flex-col gap-2 w-full">
                    <BaseInput className="w-full"
                               placeholder={t('tabelog.url_input_placeholder', 'Tabelog URL')}
                               value={tabelogUrl}
                               required={true}
                               onChange={(e) => setTabelogUrl(e.currentTarget.value)}/>
                </div>
                <div className="flex flex-row justify-between items-center gap-2">
                    {loading ? <Loading label="Computing..."/>
                        : <Button type='submit' className="sm:w-max">{t('tabelog.url_input_button', 'Search menu')}</Button>
                    }

                    {!loadingRestaurants && restaurants.length > 0 && (
                        <select
                            onChange={handleSelectRestaurant}
                            className="p-2 border rounded bg-white text-sm"
                            defaultValue=""
                        >
                            <option value="" disabled>{t('tabelog.select_restaurant', 'Select a restaurant')}</option>
                            {restaurants.map((r) => (
                                <option key={r.id} value={r.id}>
                                    {r.name} ({r.created_at})
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </form>
        </div>
    );
};

export default TabelogInput;
